export default __webpack_public_path__ + "static/media/housecontroller.202ba324.png";